import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useAuthStore } from "../store/store";
import UserDetails from "./UserDetails";

const UserDetailsPage = () => {
  const { id } = useParams();  
  const token = useAuthStore((state) => state.auth?.token);

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchDetails = async () => {
      try {
        const response = await axios.get(`/api/userdetails/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (!cancelled) setData(response.data);
      } catch (err) {
        console.error("Error fetching user details:", err);
        if (!cancelled) setError("Failed to load user details");
      }
    };

    if (token) fetchDetails();

    return () => { cancelled = true; };
  }, [id, token]);

  if (error) return <p>{error}</p>;
  if (!data || !data.user) return <p>Loading...</p>;

  return <UserDetails data={data} />;
};

export default UserDetailsPage;